import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import * as Papa from 'papaparse';
import styled from '@emotion/styled';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form } from 'antd';
import { inject } from 'mobx-react';
import { css } from '@emotion/core';
// import CommonButton from '../common/Button';
import IconSvg from '../common/IconSvg';
import { DisableMask } from '../common/FlexStyle';
import ENUMS from '../../constants/enums';
import { themeColors } from '../../constants/themes';
import { DownloadSample } from '../OnboardingScreens/AdvancedScreen7/styled';
import FileName from '../common/FileName';

const Container = styled('div')`
  background-color: #ffffff;
  padding: 20px 15px 15px 15px;
  height: 255px;
  width: 237px;
  margin-right: 15px;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  border-radius: 10px;
  position: relative;
  box-shadow: 0px 1px 7px 0 #0069fa26;
`;
const Errors = styled('div')`
  background-color: #ffffff;
  padding: 15px;
  width: 150px;
`;

const IconsWraper = styled('div')`
  display: flex;
  height: 25px;
  width: 38%;
  justify-content: space-between;
  padding: 0 3px;
  z-index: 100;
  position: absolute;
  top: 74px;
  left: 30%;
`;

const Heading = styled('div')`
  margin-bottom: 10px;
  height: 54px;
  font-size: 18px;
  color: ${themeColors.darkBlue};
  text-align: center;
  font-family: Heebo-Medium;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
`;

const ActiveHeading = styled('div')`
  width: 100%;
  height: 4px;
  background-color: #233b69;
  border-radius: 4px 4px 0 0;
  position: absolute;
  top: 0;
  left: 0;
`;

const UploadLink = styled('div')`
  height: 15px;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  text-align: left;
  position: absolute;
  bottom: 7px;
  text-align: right;
  padding-right: 7px;
  color: ${themeColors.blue};
  cursor: pointer;
  right: 10px;
  border-bottom: 1px solid ${themeColors.blue};
`;

@inject('localeStore')
@injectIntl
@Form.create()
class DiscoverById extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: null,
      isContent: false,
      fileName: '',
      spinnerShown: false,
    };
    this.dropzoneRef = null;
    this.textarea;
  }

  /**
   * on dropping file into the text area, it will automatically
   * redirect to the next step and parse it.
   * @param {File} acceptedFiles the dropped file
   */
  onDrop = acceptedFiles => {
    if (this.state.isContent) {
      return;
    }
    const self = this;
    const file = acceptedFiles[0];
    this.setState({ spinnerShown: true });
    if (
      file &&
      file.name &&
      (file.name.split('.').pop() === 'csv' ||
        file.name.split('.').pop() === 'xls' ||
        file.name.split('.').pop() === 'xlsx')
    ) {
      Papa.parse(file, {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        delimiter: ',',
        complete: results => {
          if (results.errors.length || results.meta.fields[0] !== 'id') {
            self.setState({
              errors:
                'There was an error with the format of your file. Click "See Format" to get an example',
            });
          } else {
            self.setState({ errors: '' });
            const { setDiscoverMethod } = self.props;
            setDiscoverMethod(ENUMS.DISCOVERY_METHODS.CSV);
            self.props.onChangeUpdate(results.data.map(({ id }) => id), ENUMS.COMMON.ID);
            self.setState({ isContent: true, fileName: file.name });
          }
        },
      });
    } else {
      this.setState({ errors: 'please drop only CSV file !!!' });
    }
    this.setState({ spinnerShown: false });
  };

  setContentToState = e => {
    this.props.onChangeUpdate(e, ENUMS.COMMON.ID);
    this.setState({
      isContent: e.target.value.length,
      errors: '',
    });
  };

  // handleSubmit = (e) => {
  //   const { handleSubmit } = this.props;
  //   e.preventDefault();
  //   this.props.form.validateFields((err, values) => {
  //     if (!err) {
  //       const { search } = values;
  //       handleSubmit(search, 'id');
  //     }
  //   });
  // };

  cancelFile = () => {
    this.setState({ isContent: false, fileName: '' });
    this.props.onChangeUpdate([], null);
  };

  render() {
    const {
      intl,
      isDisabled,
      isDisabledByStep,
      updatedBy,
      discoverValueString,
      localeStore: { isEL, isFR },
    } = this.props;
    const isLongTranslation = isEL || isFR;
    // const asinValidator = new RegExp('/(B00[A-Z0-9]{7})/g');
    return (
      <Container isDisabled={isDisabled} isDisabledByStep={isDisabledByStep}>
        {!isDisabled && updatedBy === ENUMS.COMMON.ID && <ActiveHeading />}
        {isDisabledByStep && <DisableMask border={10} />}
        <Heading>
          <FormattedMessage id="discover.DiscoverById" defaultMessage="Discover by ID" />
        </Heading>
        <DownloadSample
          href="/assets/sampleFiles/exampleDiscovery.csv"
          target="_blank"
          linkText={intl.formatMessage({ id: 'onboarding.advanced.screen7.seeFormat' })}
          extraCss="
            margin-top: -10px;
            width: 100%;
            text-align: right;
            display: block;
          "
        />
        <Dropzone
          accept={['application/vnd.ms-excel', '.csv', '']}
          onDrop={this.onDrop}
          ref={node => {
            this.dropzoneRef = node;
          }}
          disableClick
          disabled={isDisabledByStep}
          style={{
            height: '149px',
            marginBottom: '20px',
            border: `2px dashed ${themeColors.dirtyBlue}`,
          }}
          acceptStyle={{ border: `2px dashed ${themeColors.green}` }}
          rejectStyle={{ border: `2px dashed ${themeColors.pink}` }}
          activeStyle={{ border: `2px dashed ${themeColors.dirtyBlue}` }}
        >
          {this.state.fileName ? (
            <FileName
              name={this.state.fileName}
              type="csv"
              size={20}
              cancelHandler={this.cancelFile}
            />
          ) : (
            <React.Fragment>
              <textarea
                placeholder={intl.formatMessage({ id: 'discover.DiscoverByURLBody' })}
                onChange={this.setContentToState}
                className="DiscoveryDropZone"
                ref={node => {
                  this.textarea = node;
                }}
                defaultValue={updatedBy === ENUMS.COMMON.ID ? discoverValueString : ''}
                disabled={isDisabledByStep}
                css={css`
                  ${isLongTranslation &&
                    `
                    ::placeholder {
                      font-size: 10px !important;
                    }
                  `}
                `}
              />
              {!this.state.isContent && (
                <React.Fragment>
                  <IconsWraper>
                    <IconSvg type="copy" size={25} />
                    <IconSvg type="csv" size={25} />
                  </IconsWraper>
                  <UploadLink
                    onClick={() => {
                      this.dropzoneRef.open();
                    }}
                  >
                    {intl.formatMessage({ id: 'discover.UploadCSV' })}
                  </UploadLink>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </Dropzone>
        {/* <CommonButton
          disabled={isDisabledByStep}
        </CommonButton> */}
        {this.state.errors && <Errors>{this.state.errors}</Errors>}
        {this.state.spinnerShown ? <div className="loader" /> : null}
      </Container>
    );
  }
}

DiscoverById.propTypes = {
  intl: PropTypes.object,
  localeStore: PropTypes.object,
  onChangeUpdate: PropTypes.func,
  isDisabled: PropTypes.bool,
  isDisabledByStep: PropTypes.bool,
  updatedBy: PropTypes.number,
  discoverValueString: PropTypes.string,
};

export default DiscoverById;
